import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=a84981ba&scoped=true&"
import script from "./NavigationList.vue?vue&type=script&lang=js&"
export * from "./NavigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84981ba",
  null
  
)

export default component.exports